import { Action } from '@reduxjs/toolkit';
import { StateObservable } from 'redux-observable';
import { Observable } from 'rxjs';
import { tap, ignoreElements, filter } from 'rxjs/operators';

import { mediaActions } from '../../actions';
import {
  volumeSelector,
  videoStreamSoundSelector,
} from '../../selectors';
import { RootState } from '../../types';

let wakeLock: any = null;

const wakeLockOnMutedEpic = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(mediaActions.volume.set.match),
  tap(async () => {
    const { muted } = volumeSelector(state$.value);
    const videoStreamValue = videoStreamSoundSelector(state$.value);
    const isMuted = muted || !videoStreamValue;

    if (isMuted) {
      try {
        wakeLock = await navigator.wakeLock.request('screen');
      } catch {}
    } else if (wakeLock !== null) {
      wakeLock.release().then(() => {
        wakeLock = null;
      });
    }
  }),
  ignoreElements()
);

export default wakeLockOnMutedEpic;
